var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKmd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.509 1.432c-1.518-.506-3.786-.56-5.988-.203-2.223.358-4.698 1.184-6.538 2.723C2.866 7.397.565 11.962 1.068 17.368c.494 5.307 3.765 10.219 8.568 12.204 4.472 1.848 11.54 2.79 17.144-2.988 2.053-2.117 3.196-4.863 3.757-7.345.556-2.462.588-4.877.22-6.455a1.664 1.664 0 0 0-3.242.758c.223.956.255 2.84-.225 4.962-.474 2.1-1.403 4.218-2.9 5.762-4.25 4.383-9.633 3.82-13.483 2.228-3.52-1.455-6.13-5.199-6.524-9.435-.385-4.136 1.31-7.686 4.737-10.553 1.212-1.014 3.037-1.685 4.933-1.992 1.918-.31 3.59-.196 4.403.075a1.664 1.664 0 0 0 1.053-3.158zm-1.443 9.216c-.5-.094-1.08-.203-1.859-.203-2.608 0-5.715 1.942-5.715 5.271 0 3.33 2.109 5.715 5.715 5.715 3.606 0 5.326-3.66 5.326-5.436 0-.457-.066-.925-.133-1.4-.192-1.368-.393-2.789.967-4.149 1.248-1.248 2.058-1.233 2.729-1.22.312.007.595.012.877-.111.888-.389 2.33-1.887 1.165-3.773-1.165-1.885-3.828-.665-4.217.667-.123.428-.18.853-.233 1.26-.113.857-.215 1.633-.93 2.18-1.79 1.557-2.517 1.42-3.69 1.2z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmd);
export default __webpack_public_path__ + "static/media/KMD.7a840f6174cbae851598b9be7992719b.svg";
export { ForwardRef as ReactComponent };